"use client";
import styles from "./TournamentGrid.module.css";
type Field = {label:string; value:string; options:string[]; onChange:(value:string)=>void};
export default function TournamentFilters({fields,onReset}:{fields:Field[];onReset:()=>void}) {
  return <div className={styles.filters}>
    {fields.map(field=><label key={field.label} className={styles.filterLabel}>{field.label}
      <select className={styles.filterSelect} value={field.value} onChange={e=>field.onChange(e.target.value)}>
        <option value="all">Все</option>{field.options.map(value=><option key={value} value={value}>{value}</option>)}
      </select>
    </label>)}
    <button type="button" className={styles.filterReset} onClick={onReset}>Сбросить</button>
  </div>;
}
